(() => {
  const initialiseHeader = (headerSection) => {
    if (!headerSection || headerSection.dataset.tlvscNavigationReady === 'true') return;

    headerSection.dataset.tlvscNavigationReady = 'true';

    const desktopMenus = [...headerSection.querySelectorAll('.tlvsc-nav > .tlvsc-nav__list > li > details')];
    const mobileMenu = headerSection.querySelector('.tlvsc-mobile-menu');
    const mobileLevels = [...headerSection.querySelectorAll('[data-tlvsc-mobile-level]')];
    const mobileRoot = headerSection.querySelector('.tlvsc-mobile-level--root');
    const mobileForwardButtons = [...headerSection.querySelectorAll('.tlvsc-mobile-forward')];
    const mobileBackButtons = [...headerSection.querySelectorAll('.tlvsc-mobile-back')];
    const mobileOrigins = new Map();
    const desktopPointer = window.matchMedia('(min-width: 990px) and (hover: hover)');
    let activeMobileLevel = mobileRoot;

    const closeMenus = (menus, exception = null) => {
      menus.forEach((menu) => {
        if (menu !== exception) menu.removeAttribute('open');
      });
    };

    const positionFlyout = (nestedMenu) => {
      const flyout = nestedMenu.querySelector(':scope > .tlvsc-nav__sublist');
      if (!flyout) return;

      nestedMenu.classList.remove('tlvsc-nav__nested--flip');
      window.requestAnimationFrame(() => {
        const rect = flyout.getBoundingClientRect();
        if (rect.right > window.innerWidth - 16) {
          nestedMenu.classList.add('tlvsc-nav__nested--flip');
        }
      });
    };

    const resetMobileLevels = () => {
      mobileLevels.forEach((level) => {
        level.hidden = level !== mobileRoot;
      });
      mobileForwardButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      mobileOrigins.clear();
      activeMobileLevel = mobileRoot;
    };

    const openMobileLevel = (target, origin) => {
      if (!target || !activeMobileLevel || target === activeMobileLevel) return;

      activeMobileLevel.hidden = true;
      target.hidden = false;
      origin?.setAttribute('aria-expanded', 'true');
      if (origin) mobileOrigins.set(target.id, origin);
      activeMobileLevel = target;
      target.querySelector('.tlvsc-mobile-back')?.focus();
    };

    const returnMobileLevel = () => {
      if (!activeMobileLevel || activeMobileLevel === mobileRoot) return false;

      const parentId = activeMobileLevel.dataset.tlvscMobileParent;
      const parent = parentId ? headerSection.querySelector(`#${CSS.escape(parentId)}`) : mobileRoot;
      const origin = mobileOrigins.get(activeMobileLevel.id);

      activeMobileLevel.hidden = true;
      if (parent) parent.hidden = false;
      origin?.setAttribute('aria-expanded', 'false');
      mobileOrigins.delete(activeMobileLevel.id);
      activeMobileLevel = parent || mobileRoot;
      origin?.focus();
      return true;
    };

    desktopMenus.forEach((menu) => {
      const nestedMenus = [...menu.querySelectorAll('.tlvsc-nav__nested')];

      menu.addEventListener('toggle', () => {
        if (menu.open) {
          closeMenus(desktopMenus, menu);
        } else {
          closeMenus(nestedMenus);
        }
      });

      nestedMenus.forEach((nestedMenu) => {
        nestedMenu.addEventListener('toggle', (event) => {
          event.stopPropagation();
          if (nestedMenu.open) {
            closeMenus(nestedMenus, nestedMenu);
            positionFlyout(nestedMenu);
          } else {
            nestedMenu.classList.remove('tlvsc-nav__nested--flip');
          }
        });

        nestedMenu.addEventListener('mouseenter', () => {
          if (!desktopPointer.matches) return;
          nestedMenu.setAttribute('open', '');
          closeMenus(nestedMenus, nestedMenu);
          positionFlyout(nestedMenu);
        });

        nestedMenu.addEventListener('mouseleave', () => {
          if (!desktopPointer.matches) return;
          nestedMenu.removeAttribute('open');
        });
      });
    });

    mobileForwardButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const targetId = button.dataset.tlvscMobileTarget;
        const target = targetId ? headerSection.querySelector(`#${CSS.escape(targetId)}`) : null;
        openMobileLevel(target, button);
      });
    });

    mobileBackButtons.forEach((button) => {
      button.addEventListener('click', returnMobileLevel);
    });

    mobileMenu?.addEventListener('toggle', () => {
      if (mobileMenu.open) {
        closeMenus(desktopMenus);
      } else {
        resetMobileLevels();
      }
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('.tlvsc-nav')) closeMenus(desktopMenus);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      if (mobileMenu?.open) {
        if (returnMobileLevel()) return;
        mobileMenu.removeAttribute('open');
        resetMobileLevels();
        mobileMenu.querySelector(':scope > summary')?.focus();
        return;
      }

      const openDesktopMenu = desktopMenus.find((menu) => menu.open);
      const openNestedMenu = openDesktopMenu?.querySelector('.tlvsc-nav__nested[open]');

      if (openNestedMenu) {
        openNestedMenu.removeAttribute('open');
        openNestedMenu.querySelector(':scope > summary')?.focus();
      } else if (openDesktopMenu) {
        openDesktopMenu.removeAttribute('open');
        openDesktopMenu.querySelector(':scope > summary')?.focus();
      }
    });
  };

  const initialiseAllHeaders = (root = document) => {
    root.querySelectorAll('.tlvsc-header-section').forEach(initialiseHeader);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAllHeaders());
  } else {
    initialiseAllHeaders();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAllHeaders(event.target));
})();
